import {
  getRecordDownload,
  getRecordDownloadList,
} from '@/services/record.service';
import { getDayjsFromSecomDate } from '@/utils/date';
import Vue from 'vue';

const state = {
  downloadRcords: {},
};

// Getter functions
const getters = {};

// Mutations
const mutations = {
  setDownloadRecords(state, payload) {
    payload.forEach((record) => {
      Vue.set(state.downloadRcords, record.id, {
        ...record,
        createDateUnix: getDayjsFromSecomDate(record.createDate).unix(),
      });
    });
  },
};

// Actions
const actions = {
  async createDownloadRecords({ commit }, params) {
    const result = await getRecordDownload(params);
    if (result.archives && result.archives.length > 0) {
      commit('setDownloadRecords', result.archives);
    }
  },
  async fetchDownloadRecords({ commit }) {
    const result = await getRecordDownloadList();
    if (result.archives && result.archives.length > 0) {
      commit('setDownloadRecords', result.archives);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
